// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__12Oo4","notes":"Notes_notes__2Hn5z","note":"Notes_note__3kTox","markdown":"Notes_markdown__3ROzY"};